
import { Vue, Component } from 'vue-property-decorator';
import CarrierAccountsTable from '@/features/carrier-accounts/components/CarrierAccountsTable.vue';

@Component({
  components: {
    CarrierAccountsTable,
  },
})
export default class CarrierAccounts extends Vue {}
